/**
 * Punch In / Punch Out menu logic (Captain U, 2026-07-16).
 *
 * Pure, single-sourced so the web punch action can never drift from the real
 * backend routes (mounted at /api/v1/hr/attendance in punch.routes.ts) and so
 * the "show exactly one action based on state" rule is testable without
 * mounting the whole TopBar.
 *
 * `api` (utils/api) baseURL is '/api/v1', so these paths are relative to it.
 */

export type PunchAction = 'punch-in' | 'punch-out';

/** When punched IN you can only punch OUT, and vice-versa. */
export function nextPunchAction(punchedIn: boolean): PunchAction {
  return punchedIn ? 'punch-out' : 'punch-in';
}

/** The real backend route (relative to api baseURL '/api/v1'). */
export function punchEndpoint(action: PunchAction): string {
  return `/hr/attendance/${action}`;
}

/** Menu-item label, including the in-flight state. */
export function punchLabel(punchedIn: boolean, busy: boolean): string {
  if (punchedIn) return busy ? 'Punching out…' : 'Punch Out';
  return busy ? 'Punching in…' : 'Punch In';
}
